export { default } from './EnergiaSolarQualidade';
